const updateFeatureMutation = `
  mutation UpdateMarketplaceFeature($id: ID!, $fields: UpdateMarketplace_featureFieldsInput) {
    updateMarketplace_feature(input: { id: $id, fields: $fields }) {
      marketplace_feature {
        objectId
        name
        label
        description
        plans { ... on Element { value } }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default updateFeatureMutation;
